import { GeoAPIType, GeoAPITypeEnum } from '@shared/models/geo-api-type.model';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { forkJoin, MonoTypeOperatorFunction, Observable, of } from 'rxjs';
import {
  cameraFromAPIMapper,
  situationsFromAPIMapper,
  trafficFromAPIMapper,
  co2FromAPIMapper,
  luminaryFromAPIMapper,
  garbageFromAPIMapper,
  trafficSpeedRangeFromAPIMapper,
  trafficConcordanceFromAPIMapper,
  bicyclePathFromAPIMapper,
  parkingLotFromAPIMapper,
  trafficLightFromAPIMapper,
  aforoFromAPIMapper,
  agentsFromAPIMapper,
  trafficManagmentPlansFromAPIMapper,
  ZonesFromAPIMapper,
  RoadRunFromAPIMapper,
  skateboardFromAPIMapper,
  matrixODFromAPIMapper,
  runtFromAPIMapper,
  AirQualityPointsAPIMapper,
  ParkingSpotFromApiMapper,
  ParkingSqareFromApiMapper,
  ParkingLineFromApiMapper,
  ParkingLoadingZoneFromApiMapper,
  PanicButtonFromApiMapper,
  UndergroundParkingSpotFromApiMapper,
  matrixODcameraFromAPIMapper,
  camerapointsFromAPIMapper
} from '@shared/utils/mappers/geo-api-map';
import { LayerPath } from '@shared/models/layer-path.model';
import { AbstractMapviewerDataSource } from '@types-custom/models/ui/map-viewer-model';
import { CameraModel } from '@shared/models/camera.model';
import { TrafficApiService } from '@shared/services/layer-service/traffic-api-service/traffic-api.service';
import { Co2Service } from '@shared/services/layer-service/co2-service/co2.service';
import { AforoService } from '@shared/services/layer-service/aforo-service/aforo.service';
import { AgentsService } from '@shared/services/layer-service/agents-service/agents.service';
import { IncidentsService } from '@shared/services/layer-service/incidents-service/incidents.service';
import { pmvAPIMapper } from '@shared/utils/mappers/geo-api-map';
import { AccidentService } from '../layer-service/accident-service/accident.service';
import { separateCoordinates } from '@shared/utils/functions/separate-coordinates';
import { BusService } from '../layer-service/bus-service/bus.service';
import { ParkingService } from '../layer-service/parking-service/parking.service';
import { NameRunwayEnum } from '@shared/models/bus-zone.model';
import { ParkingSpotModel } from '@shared/models/parking-spot.model';
import { ParkingLoadingZoneModel } from '@shared/models/parking-loading-zone.model';
import { ParkingLinesEnum } from '@shared/models/parking-line.model';
import { PmvService } from '../layer-service/pmv-service/pmv.service';
import { CameraPointsModel } from '@shared/models/cameraPoint.model';

@Injectable()
export class GeoApiService implements AbstractMapviewerDataSource {
  private apiInfoTypeMap: {
    [key: string]: (
      listType: GeoAPITypeEnum,
      isAllDataLoaded?: boolean
    ) => Observable<any[]>;
  } = {
      [GeoAPITypeEnum.Camera]: this.getCameraList.bind(this),
      [GeoAPITypeEnum.Situation]: this.getSituationsList.bind(this),
      [GeoAPITypeEnum.Traffic]: this.getTrafficList.bind(this),
      [GeoAPITypeEnum.Blank]: this.getBlankList.bind(this),
      [GeoAPITypeEnum.Co2]: this.getCo2List.bind(this),
      [GeoAPITypeEnum.Luminary]: this.getLuminaryList.bind(this),
      [GeoAPITypeEnum.Garbage]: this.getGarbageList.bind(this),
      [GeoAPITypeEnum.Aforo]: this.getAforoList.bind(this),
      [GeoAPITypeEnum.TrafficSpeedRange]:
        this.getTrafficSpeedRangeList.bind(this),
      [GeoAPITypeEnum.TrafficConcordance]:
        this.getTrafficConcordanceList.bind(this),
      [GeoAPITypeEnum.BicyclePath]: this.getBicyclePathList.bind(this),
      [GeoAPITypeEnum.ParkingLot]: this.getParkingLotList.bind(this),
      [GeoAPITypeEnum.TrafficLight]: this.getTrafficLightList.bind(this),
      [GeoAPITypeEnum.Agents]: this.getAgentsList.bind(this),
      [GeoAPITypeEnum.AgentsHistorical]: this.getAgentsHistoricalList.bind(this),
      [GeoAPITypeEnum.TrafficManagmentPlans]:
        this.getTrafficManagmentPathList.bind(this),
      [GeoAPITypeEnum.StopBus]: this.getStopBusList.bind(this),
      [GeoAPITypeEnum.RouteBus]: this.getRouteBusList.bind(this),
      [GeoAPITypeEnum.Zones]: this.getZonesPathList.bind(this),
      [GeoAPITypeEnum.MatrixODsensor]: this.getMatrixODList.bind(this),
      [GeoAPITypeEnum.MatrixODcamera]: this.getMatrixODCameraList.bind(this),
      [GeoAPITypeEnum.RoadRun]: this.getRoadRunPathList.bind(this),
      [GeoAPITypeEnum.Accident]: this.getAccidentsList.bind(this),
      [GeoAPITypeEnum.Pmv]: this.getPmvList.bind(this),
      // [GeoAPITypeEnum.PmvConsulta]: this.getPmvList.bind(this),
      // [GeoAPITypeEnum.PmvEditar]: this.getPmvList.bind(this),
      [GeoAPITypeEnum.RuntDatex]: this.getRuntDatexList.bind(this),
      [GeoAPITypeEnum.Skateboards]: this.getSkateboardsList.bind(this),
      [GeoAPITypeEnum.ParkingZone]: this.getParkingZoneList.bind(this),
      [GeoAPITypeEnum.ParkingSpot]: this.getParkingSpotList.bind(this),
      [GeoAPITypeEnum.ParkingSpotBGZones]: this.getParkingSpotBlueGreenZones.bind(this),
      [GeoAPITypeEnum.ParkingSquareZones]: this.getParkingSquareZones.bind(this),
      [GeoAPITypeEnum.ParkingSpotLUZone]: this.getParkingSpotLoadUnloadZone.bind(this),
      [GeoAPITypeEnum.ParkingLine]: this.getParkingLineList.bind(this),
      [GeoAPITypeEnum.ParkingLoadingZone]: this.getParkingLoadingZoneList.bind(this),
      [GeoAPITypeEnum.ParkingUnderground]: this.getParkingSpotUnderground.bind(this),
      [GeoAPITypeEnum.PanicButton]: this.getPanicButtonList.bind(this),
      // Air Quality
      [GeoAPITypeEnum.ResourcesAirQualityPoints]: this.getAirQualityPoints.bind(this),
      [GeoAPITypeEnum.CameraPoints]: this.getCameraPointList.bind(this),
    };

  private cacheMap: { [key: string]: any[] } = {
    [GeoAPITypeEnum.Situation]: [],
    [GeoAPITypeEnum.Traffic]: [],
    [GeoAPITypeEnum.Camera]: [],
    [GeoAPITypeEnum.Blank]: [],
    [GeoAPITypeEnum.Co2]: [],
    [GeoAPITypeEnum.Luminary]: [],
    [GeoAPITypeEnum.Garbage]: [],
    [GeoAPITypeEnum.Aforo]: [],
    [GeoAPITypeEnum.TrafficSpeedRange]: [],
    [GeoAPITypeEnum.TrafficConcordance]: [],
    [GeoAPITypeEnum.BicyclePath]: [],
    [GeoAPITypeEnum.ParkingLot]: [],
    [GeoAPITypeEnum.TrafficLight]: [],
    [GeoAPITypeEnum.Agents]: [],
    [GeoAPITypeEnum.AgentsHistorical]: [],
    [GeoAPITypeEnum.TrafficManagmentPlans]: [],
    [GeoAPITypeEnum.StopBus]: [],
    [GeoAPITypeEnum.RouteBus]: [],
    [GeoAPITypeEnum.Zones]: [],
    [GeoAPITypeEnum.MatrixODsensor]: [],
    [GeoAPITypeEnum.MatrixODcamera]: [],
    [GeoAPITypeEnum.RoadRun]: [],
    [GeoAPITypeEnum.Accident]: [],
    [GeoAPITypeEnum.Pmv]: [],
    [GeoAPITypeEnum.PmvConsulta]: [],
    [GeoAPITypeEnum.PmvEditar]: [],
    [GeoAPITypeEnum.RuntDatex]: [],
    [GeoAPITypeEnum.Skateboards]: [],
    [GeoAPITypeEnum.ParkingZone]: [],
    [GeoAPITypeEnum.ParkingSquareZones]: [],
    [GeoAPITypeEnum.ParkingLoadingZone]: [],
    [GeoAPITypeEnum.ParkingUnderground]: [],
    [GeoAPITypeEnum.PanicButton]: [],
    [GeoAPITypeEnum.ParkingSpot]: [],
    [GeoAPITypeEnum.ParkingLine]: [],
    // Air Quality
    [GeoAPITypeEnum.ResourcesAirQualityPoints]: [],
    [GeoAPITypeEnum.CameraPoints]: []
  };

  private cacheDataMap: {
    [key: string]: { totalPages: number; totalRecords: number } | undefined;
  } = {
      [GeoAPITypeEnum.Situation]: undefined,
      [GeoAPITypeEnum.Traffic]: undefined,
      [GeoAPITypeEnum.Camera]: undefined,
      [GeoAPITypeEnum.Co2]: undefined,
      [GeoAPITypeEnum.Aforo]: undefined,
      [GeoAPITypeEnum.TrafficSpeedRange]: undefined,
      [GeoAPITypeEnum.TrafficConcordance]: undefined,
      [GeoAPITypeEnum.BicyclePath]: undefined,
      [GeoAPITypeEnum.ParkingLot]: undefined,
      [GeoAPITypeEnum.TrafficLight]: undefined,
      [GeoAPITypeEnum.Agents]: undefined,
      [GeoAPITypeEnum.AgentsHistorical]: undefined,
      [GeoAPITypeEnum.TrafficManagmentPlans]: undefined,
      [GeoAPITypeEnum.StopBus]: undefined,
      [GeoAPITypeEnum.RouteBus]: undefined,
      [GeoAPITypeEnum.Zones]: undefined,
      [GeoAPITypeEnum.MatrixODsensor]: undefined,
      [GeoAPITypeEnum.MatrixODcamera]: undefined,
      [GeoAPITypeEnum.RoadRun]: undefined,
      [GeoAPITypeEnum.Accident]: undefined,
      [GeoAPITypeEnum.Pmv]: undefined,
      [GeoAPITypeEnum.PmvConsulta]: undefined,
      [GeoAPITypeEnum.PmvEditar]: undefined,
      [GeoAPITypeEnum.RuntDatex]: undefined,
      [GeoAPITypeEnum.Skateboards]: undefined,
      [GeoAPITypeEnum.ParkingZone]: undefined,
      [GeoAPITypeEnum.ParkingLoadingZone]: undefined,
      [GeoAPITypeEnum.ParkingSpot]: undefined,
      [GeoAPITypeEnum.ParkingSpotBGZones]: undefined,
      [GeoAPITypeEnum.ParkingSquareZones]: undefined,
      [GeoAPITypeEnum.ParkingSpotLUZone]: undefined,
      [GeoAPITypeEnum.ParkingUnderground]: undefined,
      [GeoAPITypeEnum.PanicButton]: undefined,
      [GeoAPITypeEnum.ParkingLine]: undefined,
      // Air Quality
      [GeoAPITypeEnum.ResourcesAirQualityPoints]: undefined,
    };

  private cecheExcludedListsMap: { [key: string]: GeoAPITypeEnum } = {
    [GeoAPITypeEnum.TrafficSpeedRange]: GeoAPITypeEnum.TrafficSpeedRange,
    [GeoAPITypeEnum.TrafficConcordance]: GeoAPITypeEnum.TrafficConcordance,
    [GeoAPITypeEnum.BicyclePath]: GeoAPITypeEnum.BicyclePath,
    [GeoAPITypeEnum.Co2]: GeoAPITypeEnum.Co2,
    [GeoAPITypeEnum.Aforo]: GeoAPITypeEnum.Aforo,
    [GeoAPITypeEnum.ParkingLot]: GeoAPITypeEnum.ParkingLot,
    [GeoAPITypeEnum.TrafficLight]: GeoAPITypeEnum.TrafficLight,
    [GeoAPITypeEnum.Agents]: GeoAPITypeEnum.Agents,
    [GeoAPITypeEnum.TrafficManagmentPlans]:
      GeoAPITypeEnum.TrafficManagmentPlans,
    [GeoAPITypeEnum.StopBus]: GeoAPITypeEnum.StopBus,
    [GeoAPITypeEnum.RouteBus]: GeoAPITypeEnum.RouteBus,
    [GeoAPITypeEnum.AgentsHistorical]: GeoAPITypeEnum.AgentsHistorical,
    [GeoAPITypeEnum.Zones]: GeoAPITypeEnum.Zones,
    [GeoAPITypeEnum.MatrixODsensor]: GeoAPITypeEnum.MatrixODsensor,
    [GeoAPITypeEnum.MatrixODcamera]: GeoAPITypeEnum.MatrixODcamera,
    [GeoAPITypeEnum.RoadRun]: GeoAPITypeEnum.RoadRun,
    [GeoAPITypeEnum.Accident]: GeoAPITypeEnum.Accident,
    [GeoAPITypeEnum.Pmv]: GeoAPITypeEnum.Pmv,
    [GeoAPITypeEnum.PmvConsulta]: GeoAPITypeEnum.PmvConsulta,
    [GeoAPITypeEnum.PmvEditar]: GeoAPITypeEnum.PmvEditar,
    [GeoAPITypeEnum.Situation]: GeoAPITypeEnum.Situation,
    [GeoAPITypeEnum.ParkingZone]: GeoAPITypeEnum.ParkingZone,
    [GeoAPITypeEnum.ParkingSpot]: GeoAPITypeEnum.ParkingSpot,
    [GeoAPITypeEnum.ParkingSpotBGZones]: GeoAPITypeEnum.ParkingSpotBGZones,
    [GeoAPITypeEnum.ParkingSquareZones]: GeoAPITypeEnum.ParkingSquareZones,
    [GeoAPITypeEnum.ParkingSpotLUZone]: GeoAPITypeEnum.ParkingSpotLUZone,
    [GeoAPITypeEnum.ParkingUnderground]: GeoAPITypeEnum.ParkingUnderground,
    [GeoAPITypeEnum.ParkingLine]: GeoAPITypeEnum.ParkingLine,
    [GeoAPITypeEnum.ResourcesAirQualityPoints]: GeoAPITypeEnum.ResourcesAirQualityPoints,
    [GeoAPITypeEnum.PanicButton]: GeoAPITypeEnum.PanicButton,

  };

  private urlParser!: any;

  constructor(
    private trafficApiService: TrafficApiService,
    private co2Service: Co2Service,
    private aforoService: AforoService,
    private agentsService: AgentsService,
    private httpClient: HttpClient,
    private incidentsService: IncidentsService,
    private accidentService: AccidentService,
    private busService: BusService,
    private parkingService: ParkingService,
    private pmvService: PmvService,
    @Inject('environment') private environment: any
  ) { }

  private isCacheExcludedListType(listType: GeoAPITypeEnum): boolean {
    const isExcluded = !!this.cecheExcludedListsMap[listType];
    return isExcluded;
  }

  private get pageSize(): number {
    return this.environment.geoApiPageSize;
  }

  private parseUrl(url: string): string {
    const parser = this.urlParser;
    const parsedURL = parser?.(url) || url;
    return parsedURL;
  }

  private parseCaheUrl(url: string, listType: GeoAPITypeEnum): string {
    let parsedURL = `${url}`;
    const pageSize = this.pageSize;
    const loadedData = this.cacheMap[listType];
    const loadedDataSize = loadedData.length;
    const page = Math.trunc(loadedDataSize / pageSize);
    parsedURL = parsedURL.concat(
      `${url.includes('?') ? '&' : '?'}recordsPerPage=${pageSize}&page=${page}`
    );
    return parsedURL;
  }

  private setCachePipe(
    obsevable: Observable<any>,
    listType: GeoAPITypeEnum
  ): Observable<any> {
    return obsevable.pipe(
      map((response: any[]) => {
        const cadhedData = this.cacheMap[listType];
        this.cacheMap[listType] = [...cadhedData, ...response];
        return this.cacheMap[listType];
      })
    );
  }

  private setCacheData(
    listType: GeoAPITypeEnum,
    isAllDataLoaded: boolean
  ): MonoTypeOperatorFunction<unknown> {
    if (isAllDataLoaded) {
      return tap();
    }
    return tap((response: any) => {
      this.cacheDataMap[listType] = {
        totalPages: response.totalPages,
        totalRecords: response.totalRecords,
      };
    });
  }

  private isNewDataAvailable(listType: GeoAPITypeEnum): boolean {
    const dataSize = this.cacheMap[listType].length;
    const pageSize = this.pageSize;
    if (dataSize) {
      const page = Math.trunc(dataSize / pageSize);
      const totalPages = this.cacheDataMap[listType]?.totalPages;

      if (totalPages && page > 0 && page < totalPages) {
        const limitPerPage = pageSize * page;
        if (limitPerPage - dataSize < 0) {
          return false;
        }
        return true;
      }
      return false;
    }
    return true;
  }

  getSituationsList(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false,
    queryFilters?: string,
  ): Observable<any[]> {
    return this.incidentsService.getIncidentGeoJSON(queryFilters).pipe(
      this.setCacheData(listType, isAllDataLoaded),
      map((response: any) => {
        return response.features.map((el: any) => situationsFromAPIMapper(el));
      })
    );
  }

  private getCameraPointList(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false
  ): Observable<CameraPointsModel[]> {
    const path = LayerPath.CAMERAS;
    let url = this.parseUrl(
      `${this.environment.camerasUrl}/camera/format-geo-json?recordsPerPage=1000&page=0&state=ACTIVO`
    );
    if (!isAllDataLoaded) {
      url = this.parseCaheUrl(url, listType);
    }
    // return this.httpClient.get<any>('assets/mock/cameras.json').pipe(
      return this.httpClient.get<any>(url).pipe(
      this.setCacheData(listType, isAllDataLoaded),
      map((response: any) => {
        return (
          response?.features
            // ?.filter((item: any, index: number) => index < 200)
            .map((el: any) => camerapointsFromAPIMapper(el))
        );
      }),
      // tap((data: any) => {
      //   let group = data.reduce((result: any, currentValue: any) => {
      //     let property: string = `${currentValue?.geometry?.coordinates[0]}/${currentValue?.geometry?.coordinates[1]}`;
      //     (result[property] = result[property] || []).push(currentValue)
      //     return result;
      //   }, {})

      //   data = Object.keys(group).map(key => {
      //     let camera: CameraPointsModel[] = group[key];
      //     let classProperties = camera[0].classProperties;

      //     classProperties = camera.map(mapper => {
      //       return {
      //         address: mapper.classProperties.address,
      //         icon: mapper.classProperties.icon,
      //         id: mapper.classProperties.id,
      //         url: mapper.classProperties.url,
      //         markerPopupText: mapper.classProperties.markerPopupText,
      //         name: mapper.classProperties.name
      //       }
      //     });

      //     return {
      //       className: camera[0].className,
      //       geometry: camera[0].geometry,
      //       lat: camera[0].lat,
      //       lng: camera[0].lng,
      //       classProperties: classProperties
      //     }
      //   })

      //   return data;
      // })
    );
  }

  private getTrafficList(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false
  ): Observable<any[]> {
    // TODO: Implement mock for traffic and mapper
    // const path = LayerPath.TRAFFIC;
    // let url = `${this.environment.traffic}`;
    // let url = this.parseUrl(`${this.environment.datexUrl}/${path}/`);
    let url = this.parseUrl(`${this.environment.trafficUrl}/`);
    if (!isAllDataLoaded) {
      url = this.parseCaheUrl(url, listType);
    }
    return (
      this.httpClient
        .get<any>(url)
        // .get<any>('assets/mock/traffic_2.json')
        .pipe(
          this.setCacheData(listType, isAllDataLoaded),
          map((response: any) => {
            return (
              response?.features
                // ?.filter((item: any, index: number) => index < 200)
                .map((el: any) => trafficFromAPIMapper(el))
            );
          })
        )
    );
  }

  private getCameraList(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false
  ): Observable<CameraModel[]> {
    const path = LayerPath.CAMERAS;
    let url = this.parseUrl(
      `${this.environment.camerasUrl}/camera/format-geo-json?state=ACTIVO`
    );
    if (!isAllDataLoaded) {
      url = this.parseCaheUrl(url, listType);
    }
    // return this.httpClient.get<any>('assets/mock/cameras.json').pipe(
    return this.httpClient.get<any>(url).pipe(
      this.setCacheData(listType, isAllDataLoaded),
      map((response: any) => {
        return (
          response?.features
            // ?.filter((item: any, index: number) => index < 200)
            .map((el: any) => cameraFromAPIMapper(el))
        );
      })
    );
  }

  private getCo2List(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false
  ): Observable<any[]> {
    const path = LayerPath.CO2;
    let url = this.parseUrl(`${this.environment.layersUrl}/${path}/`);
    if (!isAllDataLoaded) {
      url = this.parseCaheUrl(url, listType);
    }
    return forkJoin({
      geoCo2: this.co2Service.getCo2GeoJson(),
      measurementsCo2: this.co2Service.getMeasurementCo2(),
    }).pipe(
      this.setCacheData(listType, isAllDataLoaded),
      map((response: any) => {
        response = this.co2Service.getCo2Mapper(response);
        return response.map((el: any) => co2FromAPIMapper(el));
      })
    );
  }

  private getLuminaryList(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false
  ): Observable<any[]> {
    //const path = LayerPath.LUMINARY;
    const url = this.parseUrl(`${this.environment.luminary}/lighting/format-geo-json`);
    //let url = 'assets/mock/luminarys.json';
    //const url = 'https://gateway.sitbogota.com/luminaries/api/v1/lighting/format-geo-json';

    // if (!isAllDataLoaded) {
    //   url = this.parseCaheUrl(url, listType);
    // }
    return this.httpClient.get<any>(url).pipe(
      this.setCacheData(listType, isAllDataLoaded),
      map((response: any) => {
        return response.features.map((el: any) => luminaryFromAPIMapper(el));
      })
    );
  }

  private getGarbageList(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false
  ): Observable<any[]> {
    //const path = LayerPath.GARBAGE;
    let url = this.parseUrl(`${this.environment.cameraStream}/waste-container/format-geo-json`);
    //let url = 'assets/mock/garbages.json';

    if (!isAllDataLoaded) {
      url = this.parseCaheUrl(url, listType);
    }
    return this.httpClient.get<any>(url).pipe(
      this.setCacheData(listType, isAllDataLoaded),
      map((response: any) => {
        return response.features.map((el: any) => garbageFromAPIMapper(el));
      })
    );
  }

  private getAforoList(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false
  ): Observable<any[]> {
    return forkJoin({
      geoAforo: this.aforoService.getLayerAforoGeoJson(),
      // measurementsAforo: this.aforoService.getPanelAforoMeasurements(),
    }).pipe(
      this.setCacheData(listType, isAllDataLoaded),
      map((response: any) => {
        return response.geoAforo.features.map((el: any) => aforoFromAPIMapper(el));
      })
    );
  }

  private getTrafficSpeedRangeList(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false
  ): Observable<any[]> {
    let url = this.parseUrl(
      `${this.environment.trafficUrl}/traffic-geom/format-geo-json`
    );
    if (!isAllDataLoaded) {
      url = this.parseCaheUrl(url, listType);
    }

    return forkJoin({
      geoTraffic: this.trafficApiService.getGeoTraffic()
    }).pipe(
      //return this.httpClient.get<any>(url)
      //.pipe(
      this.setCacheData(listType, isAllDataLoaded),
      map((response: any) => {
        response = this.trafficApiService.getTrafficMapper(response);
        return (
          response?.features
            // ?.filter((item: any, index: number) => index < 200)
            .map((el: any) => trafficSpeedRangeFromAPIMapper(el))
        );
      })
    );
  }

  private getTrafficConcordanceList(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false
  ): Observable<any[]> {
    let url = this.parseUrl(
      `${this.environment.trafficUrl}/traffic-geom/format-geo-json`
    );
    if (!isAllDataLoaded) {
      url = this.parseCaheUrl(url, listType);
    }

    return forkJoin({
      geoTraffic: this.trafficApiService.getGeoTraffic()
    }).pipe(
      this.setCacheData(listType, isAllDataLoaded),
      map((response: any) => {
        response = this.trafficApiService.getTrafficMapper(response);
        return (
          response?.features
            // ?.filter((item: any, index: number) => index < 200)
            .map((el: any) => trafficConcordanceFromAPIMapper(el))
        );
      })
    );
  }

  private getBicyclePathList(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false
  ): Observable<any[]> {
    /*let url = this.parseUrl(
      `${this.environment.baseStaticLayerUrl}/18/query?where=1%3D1&text=&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&distance=&units=esriSRUnit_Foot&relationParam=&outFields=*&returnGeometry=true&returnTrueCurves=false&maxAllowableOffset=&geometryPrecision=&outSR=&havingClause=&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&historicMoment=&returnDistinctValues=false&resultOffset=&resultRecordCount=&returnExtentOnly=false&datumTransformation=&parameterValues=&rangeValues=&quantizationParameters=&featureEncoding=esriDefault&f=geojson`
    );*/
    let url = `${this.environment.runwayUrl}/runway/${NameRunwayEnum.EstacionesPrestamobicis}`;
    if (!isAllDataLoaded) {
      url = this.parseCaheUrl(url, listType);
    }
    return this.httpClient.get<any>(url).pipe(
      //return this.httpClient.get<any>('assets/mock/bicyclepath.json').pipe(
      this.setCacheData(listType, isAllDataLoaded),
      map((response: any) =>
        response?.features.map((el: any) => bicyclePathFromAPIMapper(el))
      )
    );
  }

  private getParkingLotList(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false
  ): Observable<any[]> {
    let url = this.parseUrl(
      `${this.environment.baseStaticLayerUrl}/17/query?where=1%3D1&text=&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&distance=&units=esriSRUnit_Foot&relationParam=&outFields=*&returnGeometry=true&returnTrueCurves=false&maxAllowableOffset=&geometryPrecision=&outSR=&havingClause=&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&historicMoment=&returnDistinctValues=false&resultOffset=&resultRecordCount=&returnExtentOnly=false&datumTransformation=&parameterValues=&rangeValues=&quantizationParameters=&featureEncoding=esriDefault&f=geojson`
    );
    if (!isAllDataLoaded) {
      url = this.parseCaheUrl(url, listType);
    }
    return this.httpClient
      .get<any>(url)

      .pipe(
        this.setCacheData(listType, isAllDataLoaded),
        map((response: any) =>
          response?.features.map((el: any) => parkingLotFromAPIMapper(el))
        )
      );
  }

  private getTrafficLightList(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false
  ): Observable<any[]> {
    let url = this.parseUrl(
      `${this.environment.baseStaticLayerUrl}/4/query?where=1%3D1+and+ACTIVO%3D1&text=&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&distance=&units=esriSRUnit_Foot&relationParam=&outFields=*&returnGeometry=true&returnTrueCurves=false&maxAllowableOffset=&geometryPrecision=&outSR=&havingClause=&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&historicMoment=&returnDistinctValues=false&resultOffset=&resultRecordCount=&returnExtentOnly=false&datumTransformation=&parameterValues=&rangeValues=&quantizationParameters=&featureEncoding=esriDefault&f=geojson`
    );
    if (!isAllDataLoaded) {
      url = this.parseCaheUrl(url, listType);
    }
    return this.httpClient
      .get<any>(url)

      .pipe(
        this.setCacheData(listType, isAllDataLoaded),
        map((response: any) =>
          response?.features.map((el: any) => trafficLightFromAPIMapper(el))
        )
      );
  }

  private getAgentsList(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false
  ): Observable<any[]> {
    return this.agentsService.getAgentsGeoJSON().pipe(
      this.setCacheData(listType, isAllDataLoaded),
      map((response: any) => {
        return response.features.map((el: any) => agentsFromAPIMapper(el));
      })
    );
  }

  private getAgentsHistoricalList(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false
  ): Observable<any[]> {
    return this.agentsService.getAgentsHistoricalGeoJSON().pipe(
      this.setCacheData(listType, isAllDataLoaded),
      map((response: any) => {
        return this.agentsService.getAgentsMapper(response);
      })
    );
  }

  private getZonesPathList(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false
  ): Observable<any[]> {
    let url = this.parseUrl(
      `${this.environment.baseStaticLayerUrl}/23/query?where=1%3D1&text=&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&distance=&units=esriSRUnit_Foot&relationParam=&outFields=*&returnGeometry=true&returnTrueCurves=false&maxAllowableOffset=&geometryPrecision=&outSR=&havingClause=&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&historicMoment=&returnDistinctValues=false&resultOffset=&resultRecordCount=&returnExtentOnly=false&datumTransformation=&parameterValues=&rangeValues=&quantizationParameters=&featureEncoding=esriDefault&f=geojson`
    );
    if (!isAllDataLoaded) {
      url = this.parseCaheUrl(url, listType);
    }
    return this.httpClient.get<any>(url).pipe(
      this.setCacheData(listType, isAllDataLoaded),
      map((response: any) =>
        response?.features.map((el: any) => ZonesFromAPIMapper(el))
      )
    );
  }

  private getRoadRunPathList(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false
  ): Observable<any[]> {
    let url = this.parseUrl(
      `${this.environment.baseStaticLayerUrl}/19/query?where=1%3D1&text=&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&distance=&units=esriSRUnit_Foot&relationParam=&outFields=*&returnGeometry=true&returnTrueCurves=false&maxAllowableOffset=&geometryPrecision=&outSR=&havingClause=&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&historicMoment=&returnDistinctValues=false&resultOffset=&resultRecordCount=&returnExtentOnly=false&datumTransformation=&parameterValues=&rangeValues=&quantizationParameters=&featureEncoding=esriDefault&f=geojson`
    );
    if (!isAllDataLoaded) {
      url = this.parseCaheUrl(url, listType);
    }
    return this.httpClient.get<any>(url).pipe(
      this.setCacheData(listType, isAllDataLoaded),
      map((response: any) =>
        response?.features.map((el: any) => RoadRunFromAPIMapper(el))
      )
    );
  }

  private getSkateboardsList(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false
  ): Observable<CameraModel[]> {
    const path = LayerPath.CAMERAS;
    let url = `${this.environment.runwayUrl}/runway/${NameRunwayEnum.Aparcapatinetes}`;
    if (!isAllDataLoaded) {
      url = this.parseCaheUrl(url, listType);
    }
    //return this.httpClient.get<any>('assets/mock/skateboards.json').pipe(
    return this.httpClient.get<any>(url).pipe(
      this.setCacheData(listType, isAllDataLoaded),
      map((response: any) => {
        return (
          response?.features
            // ?.filter((item: any, index: number) => index < 200)
            .map((el: any) => skateboardFromAPIMapper(el))
        );
      })
    );
  }

  private getAccidentsList(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false
  ): Observable<any[]> {
    return this.accidentService.getAccidentGeoJson().pipe(
      this.setCacheData(listType, isAllDataLoaded),
      map((response: any) => this.accidentService.getAccidentMapper(response))
    );
  }

  private getParkingSpotList(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false
  ): Observable<any[]> {
    return this.parkingService.getParkingZoneSpotGeoJson().pipe(
      this.setCacheData(listType, isAllDataLoaded),
      map((response: any) => {
        return response.features.map((el: any) => ParkingSpotFromApiMapper(el));
      })
    );
  }

  private getParkingSpotBlueGreenZones(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false
  ) {
    return this.getParkingSpotListFilter(
      listType, isAllDataLoaded,
      {
        zones: [ParkingLinesEnum.BLUE_ZONE, ParkingLinesEnum.GREEN_ZONE]
      }
    );
  }

  private getParkingSquareZones(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false
  ) {
    return this.getParkingSquareListFilter(
      listType, isAllDataLoaded,
      {
        zones: [ParkingLinesEnum.DISABLED_ZONE]
      }
    );
  }

  private getParkingSpotLoadUnloadZone(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false
  ) {
    return this.getParkingSpotListFilter(
      listType, isAllDataLoaded,
      {
        zones: [ParkingLinesEnum.LOAD_ZONE]
      }
    );
  }

  getParkingSpotUnderground(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false,
  ): Observable<ParkingSpotModel[]> {
    return this.parkingService.getParkingZoneUndergroundGeoJson().pipe(
      this.setCacheData(listType, isAllDataLoaded),
      map((response: any) => {
        return response.features.map((el: any) => UndergroundParkingSpotFromApiMapper(el));
      })
    );
  }
  getParkingSpotListFilter(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false,
    filter: any
  ): Observable<ParkingSpotModel[]> {
    return this.parkingService.getParkingZoneSpotGeoJsonFilter(filter).pipe(
      this.setCacheData(listType, isAllDataLoaded),
      map((response: any) => {
        return response.features.map((el: any) => ParkingSpotFromApiMapper(el));
      })
    );
  }

  getParkingSquareListFilter(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false,
    filter: any
  ): Observable<ParkingSpotModel[]> {
    filter.zones = [ParkingLinesEnum.DISABLED_ZONE];
    return this.parkingService.getParkingZoneSpotGeoJsonFilter(filter).pipe(
      this.setCacheData(listType, isAllDataLoaded),
      map((response: any) => {
        return response.features.map((el: any) => ParkingSqareFromApiMapper(el));
      })
    );
  }

  getParkingLineList(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false,
    params?: { categories?: string[] }
  ): Observable<any[]> {
    const filter = params ?? {}
    if (!filter.categories)
      filter.categories = [ParkingLinesEnum.BLUE_ZONE, ParkingLinesEnum.GREEN_ZONE];
    return this.parkingService.getParkingStreeGeoJson(filter).pipe(
      this.setCacheData(listType, isAllDataLoaded),
      map((response: any) => {
        return response.features.map((el: any) => ParkingLineFromApiMapper(el));
      })
    );
  }

  private getPanicButtonList(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false,
  ): Observable<any[]> {
    //const url = 'assets/mock/panic-buttons.json';
    const url = `${this.environment.environmentalUrl}/panic-button/format-geo-json`;

    return this.httpClient
      .get<any>(url)
      .pipe(
        this.setCacheData(listType, isAllDataLoaded),
        map((response: any) => {
          const features = response?.features ?? [];
          return features.map((feature: any) => PanicButtonFromApiMapper(feature));
        })
      );
  }

  getParkingLoadingZoneList(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false
  ): Observable<ParkingLoadingZoneModel[]> {
    return this.parkingService.getParkingLoadingZoneGeoJson().pipe(
      this.setCacheData(listType, isAllDataLoaded),
      map((response: any) => {
        return response.features.map((el: any) => ParkingLoadingZoneFromApiMapper(el));
      })
    );
  }

  private getParkingZoneList(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false
  ): Observable<any[]> {
    let url = this.parseUrl(
      `${this.environment.trafficUrl}/traffic-geom/format-geo-json`
    );
    if (!isAllDataLoaded) {
      url = this.parseCaheUrl(url, listType);
    }

    return forkJoin({
      geoTraffic: this.trafficApiService.getGeoTraffic()
    }).pipe(
      //return this.httpClient.get<any>(url)
      //.pipe(
      this.setCacheData(listType, isAllDataLoaded),
      map((response: any) => {
        response = this.trafficApiService.getTrafficMapper(response);
        return (
          response?.features
            // ?.filter((item: any, index: number) => index < 200)
            .map((el: any) => trafficSpeedRangeFromAPIMapper(el))
        );
      })
    );
  }

  private getBlankList(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false
  ): Observable<CameraModel[]> {
    return this.httpClient
      .get<any>('assets/mock/blank.json')
      .pipe(
        map((response: any) =>
          response?.features.map((el: any) => cameraFromAPIMapper(el))
        )
      );
  }

  private clearCache(listType: GeoAPITypeEnum): void {
    this.cacheMap[listType] = [];
  }

  setUrlParser(fn: any): void {
    this.urlParser = fn;
  }

  getAPIList(
    listType: GeoAPITypeEnum,
    isClearingCache: boolean,
    isAllDataLoaded: boolean
  ): Observable<GeoAPIType[]> {
    if (this.isCacheExcludedListType(listType)) {
      // TODO: SINITT-800: Photo detection loads two endpoints, that's why it's necessary to set isClearingCache as true.
      isClearingCache = true;
    }

    const fn = this.apiInfoTypeMap[listType];
    if (isClearingCache) {
      this.clearCache(listType);
      return fn(listType, true);
    }

    const isNewData = this.isNewDataAvailable(listType);
    if (isNewData) {
      return this.setCachePipe(fn(listType, isAllDataLoaded), listType);
    } else {
      return of(this.cacheMap[listType]);
    }
  }

  private getRuntDatexList(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false
  ): Observable<any[]> {
    const path = LayerPath.CAMERAS;
    let url = this.parseUrl(
      `${this.environment.camerasUrl}/camera/format-geo-json?cameraType=LPR&state=ACTIVO`
    );
    if (!isAllDataLoaded) {
      url = this.parseCaheUrl(url, listType);
    }

    return this.httpClient.get<any>(url).pipe(
      this.setCacheData(listType, isAllDataLoaded),
      map((response: any) => {
        const filteredGeoJson = separateCoordinates(response);
        return filteredGeoJson.features.map((el: any) => runtFromAPIMapper(el));
      })
    );
  }

  private getPmvList(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false
  ): Observable<any[]> {
    let state: any

    return this.pmvService.getListStatus().pipe(
      switchMap((res: any) => {

        state = res.filter((i: any) => i.name == "Activo")
        const path = LayerPath.PMV;
        const url = `${this.environment.vmsUrl}/vms/format-geo-json?recordsPerPage=1000&page=0&statusId=${state[0].value}`;
        return this.httpClient.get<any>(url).pipe(
          this.setCacheData(listType, isAllDataLoaded),
          map((response: any) =>
            response?.features.map((el: any) => pmvAPIMapper(el))
          ),
          catchError(err => {
            console.error('HTTP request error: ', err);
            return of([]); // Return an empty observable in case of HTTP error
          })
        );
      }),
    );
  }

  private getMatrixODCameraList(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false
  ): Observable<any[]> {
    const url = `${this.environment.camerasUrl}/camera/format-geo-json?recordsPerPage=1000&page=0&state=ACTIVO&cameraType=LPR`;
    return (
      this.httpClient
        ///.get<any>('assets/mock/matrix-od-layer-mock.json')
        .get<any>(url)
        .pipe(
          this.setCacheData(listType, isAllDataLoaded),
          map((response: any) =>
            response?.features.map((el: any) => matrixODcameraFromAPIMapper(el)),
          )
        )
    );
  }
  private getMatrixODList(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false
  ): Observable<any[]> {
    const url = `${this.environment.trafficUrl}/device/format-geo-json?recordsPerPage=10000000&page=0&source=VCC`;
    return (
      this.httpClient
        ///.get<any>('assets/mock/matrix-od-layer-mock.json')
        .get<any>(url)
        .pipe(
          this.setCacheData(listType, isAllDataLoaded),
          map((response: any) =>
            response?.features.map((el: any) => matrixODFromAPIMapper(el))
          )
        )
    );
  }

  private getTrafficManagmentPathList(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false
  ): Observable<any[]> {
    let url = this.parseUrl(
      `${this.environment.baseStaticLayerUrl}/21/query?where=1%3D1+And+VIGENCIA+%3D+%27VIGENTE%27&text=&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&distance=&units=esriSRUnit_Foot&relationParam=&outFields=*&returnGeometry=true&returnTrueCurves=false&maxAllowableOffset=&geometryPrecision=&outSR=&havingClause=&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&historicMoment=&returnDistinctValues=false&resultOffset=&resultRecordCount=&returnExtentOnly=false&datumTransformation=&parameterValues=&rangeValues=&quantizationParameters=&featureEncoding=esriDefault&f=geojson`
    );
    if (!isAllDataLoaded) {
      url = this.parseCaheUrl(url, listType);
    }
    return this.httpClient.get<any>(url).pipe(
      this.setCacheData(listType, isAllDataLoaded),
      map((response: any) =>
        response?.features.map((el: any) =>
          trafficManagmentPlansFromAPIMapper(el)
        )
      )
    );
  }

  getRouteBusList(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false,
    lineId?: string,
  ): Observable<any[]> {
    return this.busService.getRouteBusGeoJson(lineId).pipe(
      this.setCacheData(listType, isAllDataLoaded),
      map((response: any) => this.busService.getRouteBusMapper(response))
    );
  }

  getStopBusList(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false,
    stopId?: string,
  ): Observable<any[]> {
    return this.busService.getStopBusGeoJson(stopId).pipe(
      this.setCacheData(listType, isAllDataLoaded),
      map((response: any) => this.busService.getStopBusMapper(response))
    );
  }

  // Air Quality
  getAirQualityPoints(
    listType: GeoAPITypeEnum,
    isAllDataLoaded = false,
    queryFilter?: any
  ): Observable<any[]> {
    // let url = this.parseUrl(
    //     `${this.environment.CO2Url}/api/v1/waze/alerts/duplicates/format-geo-json`
    // );
    // if (!isAllDataLoaded) {
    //   url = this.parseCaheUrl(url, listType);
    // }
    return this.co2Service.getAirQualityGeoJson(queryFilter).pipe(
      this.setCacheData(listType, isAllDataLoaded),
      map((response: any) => {
        return (
          response.features.map((el: any) => AirQualityPointsAPIMapper(el))
        );
      })
    )
  }
}
